import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  padding: 200px 0 160px 0;

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 160px 0 60px;
  }

  h1 {
    font-family: 'Anton', sans-serif;
    font-size: 120px;
    text-transform: uppercase;
    line-height: 136px;
    letter-spacing: 0.8px;
    margin-bottom: 32px;
    z-index: 1;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 48px;
      line-height: 56px;
    }
  }
`;

export const ImgBackground = styled.img`
  width: 100%;
  max-width: 600px;
  position: absolute;
  right: -7%;
  /* top: 12%; */
  z-index: 0;

  @media ${({ theme }) => theme.devices.notebook} {
    max-width: 430px;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    max-width: 230px;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    max-width: 160px;
  }
`;
